import { Notification } from '../types/props';
import { Sound } from '../lib/notification';

/**
 * Todo: Implement notification send logic
 * Send notification which will be displayed in the `<dyte-notifications />` component.
 * @param notification Notification object
 * @param playSound Sound type, if sound type is sent plays that sound with the notification.
 * @returns Return value of emitting the event
 */
export const sendNotification = (
  notification: Notification,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  playSound: Sound | undefined = undefined
) => {};
